import { Text } from '@hhgtech/hhg-components/mantine'
import { Missed } from '@hhgtech/icons/other'
import { Box, BoxProps, Stack, rem } from '@mantine/core'
import { useIntl } from 'react-intl'

import { useIsMobile } from 'hooks/useIsMobile'

import useStyles from './index.styles'

type Props = {
  title?: string
  content?: string
} & BoxProps

const Disclaimer = ({ title, content, styles, classNames }: Props) => {
  const { formatMessage: f } = useIntl()
  const { classes, theme } = useStyles(undefined, {
    name: 'Disclaimer',
    styles,
    classNames,
  })
  const isMobile = useIsMobile()
  return title || content ? (
    <Stack className={classes.root} spacing={rem(4)}>
      {title && (
        <Box>
          <Missed
            className={classes.icon}
            isSolid
            color={theme.colors.yellow[8]}
            size={isMobile ? 18 : 24}
          />
          <Text size="s4" weight="semiBold" as="span" className={classes.title}>
            {title ||
              f({
                id: 'confirmLeavePage.title',
                defaultMessage: 'Leaving HHG page',
              })}
          </Text>
        </Box>
      )}
      <Text size="p4" className={classes.content}>
        {content}
      </Text>
    </Stack>
  ) : null
}

export { Disclaimer }
